import ContactsHandler from './components/ContactsHandler'
export default ContactsHandler
